import { render, staticRenderFns } from "./AppLocaleSwitch.vue?vue&type=template&id=fc5d3a82"
import script from "./AppLocaleSwitch.vue?vue&type=script&lang=ts"
export * from "./AppLocaleSwitch.vue?vue&type=script&lang=ts"
import style0 from "./AppLocaleSwitch.vue?vue&type=style&index=0&id=fc5d3a82&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports